// Carry Roll Settings slice — units, modes, theme, fidelity. localStorage-backed.

import type { StateCreator } from 'zustand';
import {
  DistanceMode,
  Fidelity,
  InputMode,
  type SettingsState,
} from '@carry-roll/shared-types';

export type Theme = 'light' | 'dark' | 'system';

export interface SettingsSlice extends SettingsState {
  persistError: string | null;
  /** Whether the "Load Demo" link is shown in the header (default: enabled). */
  showLoadDemo: boolean;
  /** Usable fairway width in metres — shared across tee optimizer + fairway-hit panel. */
  fairwayWidthM: number;
  /** Active color theme. 'system' follows the OS-level preference. */
  theme: Theme;
  setUnits: (patch: Partial<Pick<SettingsState, 'distanceUnit' | 'speedUnit' | 'heightUnit'>>) => void;
  setInputMode: (m: InputMode) => void;
  setDistanceMode: (m: DistanceMode) => void;
  setFidelity: (f: Fidelity) => void;
  setShowLoadDemo: (v: boolean) => void;
  setFairwayWidth: (m: number) => void;
  setTheme: (t: Theme) => void;
  clearPersistError: () => void;
}

export const createSettingsSlice: StateCreator<SettingsSlice, [], [], SettingsSlice> = (set) => ({
  distanceUnit: 'yd',
  speedUnit: 'mph',
  heightUnit: 'ft',
  inputMode: InputMode.Basic,
  distanceMode: DistanceMode.Carry,
  fidelity: Fidelity.Full,
  version: 1,
  persistError: null,
  showLoadDemo: true,
  fairwayWidthM: 40,
  theme: 'system',
  setUnits: (patch) => set(patch),
  setInputMode: (inputMode) => set({ inputMode }),
  setDistanceMode: (distanceMode) => set({ distanceMode }),
  setFidelity: (fidelity) => set({ fidelity }),
  setShowLoadDemo: (showLoadDemo) => set({ showLoadDemo }),
  setFairwayWidth: (fairwayWidthM) => set({ fairwayWidthM }),
  setTheme: (theme) => set({ theme }),
  clearPersistError: () => set({ persistError: null }),
});
